import { ThemeColors, createContrastColorScale, createColorScale, } from '@theme/foundations/colors';
import { parseRawBoolean } from '@data/api/helpers';
import { normalizeRedirectUrl } from '@business/utils/url';
import MultilangText from './MultilangText';
export default class Settings {
    constructor({ custom, settings, show_estimated_arrival_time, smart_policies_enabled, }) {
        var _a, _b, _c, _d, _e, _f;
        Object.defineProperty(this, "accommodationTypeFiltering", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "allowedBookingLanguages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "amenityFiltering", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "askCompanyName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "askCompanyTaxID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "askEstimatedArrivalTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "askGender", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "askGuestTaxID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "askNationality", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "askPostalAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "bookingEstimatedArrivalTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "colors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: Object.assign({}, ThemeColors)
        });
        Object.defineProperty(this, "coverImageUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "defaultFilteredOccupantsToTwo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "defaultRoomCardState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'collapsed'
        });
        Object.defineProperty(this, "displayAddons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "logoLinkUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "occupancyFilterPreference", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'guests'
        });
        Object.defineProperty(this, "optInSettings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { isEnabled: false }
        });
        Object.defineProperty(this, "ratePriceSorting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "redirectAfterReservation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "redirectDelay", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "redirectUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "requireAcceptTerms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "requireCvv", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "requirePhoneNumber", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "showCurrencyIndicators", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "showLowestRatesOnCalendar", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "showMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "showRestrictionsOnCalendar", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "showUnavailableRooms", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "smartPoliciesEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "totalPriceForStay", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        this.showMap = !parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.hideMap);
        this.showRestrictionsOnCalendar =
            (settings === null || settings === void 0 ? void 0 : settings.showRestrictionsOnCalendar) === undefined
                ? true
                : parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.showRestrictionsOnCalendar);
        this.showLowestRatesOnCalendar = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.showLowestRatesOnCalendar);
        this.askPostalAddress = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.bookingPostalAddress);
        this.askNationality = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.bookingNationality);
        this.askGender = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.bookingGender);
        this.askGuestTaxID = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.askGuestTaxIdNumber);
        this.askCompanyName = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.askCompanyName);
        this.askCompanyTaxID = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.askCompanyTaxIdNumber);
        this.smartPoliciesEnabled = smart_policies_enabled || false;
        this.requirePhoneNumber = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.bookingRequireTelephone);
        this.askEstimatedArrivalTime =
            parseRawBoolean(show_estimated_arrival_time) &&
                (settings === null || settings === void 0 ? void 0 : settings.bookingEstimatedArrivalTime) !== '0';
        this.bookingEstimatedArrivalTime =
            !!(settings === null || settings === void 0 ? void 0 : settings.bookingEstimatedArrivalTime) &&
                (settings === null || settings === void 0 ? void 0 : settings.bookingEstimatedArrivalTime) !== '0'
                ? settings.bookingEstimatedArrivalTime
                : {};
        this.bookingEstimatedArrivalTime.notAllowedHours = Array.isArray(this.bookingEstimatedArrivalTime.notAllowedHours)
            ? this.bookingEstimatedArrivalTime.notAllowedHours
            : [];
        this.requireAcceptTerms = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.bookingRequireTermsConditions);
        this.redirectAfterReservation = !!(settings === null || settings === void 0 ? void 0 : settings.bookingRedirectUrl);
        this.logoLinkUrl = (custom === null || custom === void 0 ? void 0 : custom.logoLinkUrl) || '';
        this.redirectDelay =
            !!(settings === null || settings === void 0 ? void 0 : settings.bookingRedirectUrl) && settings.bookingRedirectUrl !== '0'
                ? parseInt((_a = settings === null || settings === void 0 ? void 0 : settings.bookingRedirectUrl) === null || _a === void 0 ? void 0 : _a.time)
                : 0;
        this.redirectUrl = normalizeRedirectUrl(!!(settings === null || settings === void 0 ? void 0 : settings.bookingRedirectUrl) && (settings === null || settings === void 0 ? void 0 : settings.bookingRedirectUrl) !== '0'
            ? (_b = settings === null || settings === void 0 ? void 0 : settings.bookingRedirectUrl) === null || _b === void 0 ? void 0 : _b.url
            : '');
        this.requireCvv = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.bookingSettingsCvv);
        this.totalPriceForStay = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.totalPriceForStay);
        this.showCurrencyIndicators = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.showCurrencyIndicators);
        this.allowedBookingLanguages = (settings === null || settings === void 0 ? void 0 : settings.allowedBookingLanguages) || [];
        this.showUnavailableRooms = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.showUnavailableRooms);
        this.coverImageUrl = (custom === null || custom === void 0 ? void 0 : custom.coverImageUrl) || '';
        this.accommodationTypeFiltering =
            (settings === null || settings === void 0 ? void 0 : settings.accommodationTypeFiltering) === undefined
                ? true
                : parseRawBoolean(settings.accommodationTypeFiltering);
        this.amenityFiltering =
            (settings === null || settings === void 0 ? void 0 : settings.amenityFiltering) === undefined
                ? true
                : parseRawBoolean(settings.amenityFiltering);
        // BENG-3949: opt-in, so default OFF (plain parse — undefined → false).
        this.ratePriceSorting = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.ratePriceSorting);
        this.defaultFilteredOccupantsToTwo = parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.defaultFilteredOccupantsToTwo);
        this.defaultRoomCardState = (settings === null || settings === void 0 ? void 0 : settings.defaultRoomCardState) || 'collapsed';
        this.occupancyFilterPreference =
            (_c = settings === null || settings === void 0 ? void 0 : settings.occupancyFilterPreference) !== null && _c !== void 0 ? _c : 'guests';
        this.displayAddons = (settings === null || settings === void 0 ? void 0 : settings.displayAddons) || 'preCheckout';
        this.optInSettings = {
            isEnabled: parseRawBoolean(settings === null || settings === void 0 ? void 0 : settings.isOptInOutEnabledOnBooking),
        };
        if (this.optInSettings.isEnabled) {
            this.optInSettings.description = new MultilangText((_d = settings === null || settings === void 0 ? void 0 : settings.optInSettings) === null || _d === void 0 ? void 0 : _d.opt_in_description_text);
            this.optInSettings.optInText = new MultilangText((_e = settings === null || settings === void 0 ? void 0 : settings.optInSettings) === null || _e === void 0 ? void 0 : _e.opt_in_option_text);
            this.optInSettings.optOutText = new MultilangText((_f = settings === null || settings === void 0 ? void 0 : settings.optInSettings) === null || _f === void 0 ? void 0 : _f.opt_out_option_text);
        }
        if (custom === null || custom === void 0 ? void 0 : custom.colors) {
            const colorsSetByUser = custom.colors;
            this.colors.primary = createColorScale(colorsSetByUser.primary || ThemeColors.primary[500]);
            this.colors.primaryContrast = createContrastColorScale(this.colors.primary[600]);
            this.colors.headerBackground = createColorScale(colorsSetByUser.header || ThemeColors.headerBackground[500]);
            this.colors.mainPageBackground = createColorScale(colorsSetByUser.mainPageBackground ||
                ThemeColors.mainPageBackground[500]);
            this.colors.background = createColorScale(colorsSetByUser.background);
        }
    }
}
